const formatTime = time => {
  const splittedTime = time.split(':');

  if (splittedTime[0].length <= 1) {
    return `0${splittedTime[0]}:${splittedTime[1]}`;
  }

  return `${splittedTime[0]}:${splittedTime[1]}`;
};

export default formatTime;



// WEBPACK FOOTER //
// ../utils/functions/time.js